import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getClientGuid } from '@fi-shared/utils/client-guid';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class FiClientGuidInterceptor implements HttpInterceptor {
    constructor(private fiBackend: FiBackendService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.fiBackend.isExternalApiUrl(request.url)) {
            request = request.clone({
                setHeaders: {
                    'Fi-Client-Guid': getClientGuid(),
                },
            });
        }
        return next.handle(request);
    }
}
